<template>
  <IQOS :hideTitle="true">
    <h4 class="queue-link cafe-card-link mb-0">
      {{ $t("general.cafe.panelid") }}
      <span class="queue-id c-green">{{ cafe.qId }}</span>
    </h4>
    <h4 class="cafe-card-link mt-15">
      {{ $t("general.cafe.panel") }}
      <a
        :href="`https://queue.qrwaiter.com.ua/login/${cafe.qId}`"
        target="_blank"
        class="c-green"
        >queue.qrwaiter.com.ua/login/{{ cafe.qId }}</a
      >
    </h4>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

export default {
  components: {
    IQOS,
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style>

</style>
